import api from './apiLibrary';

const API = {
    getSeasons(params) {
        return api.get('/api/seasons', params);
    },
};

export default API;
